/**
 * TanStack Query hooks for `date-range-timezone-picker`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dateRangeTimezonePickerQueryKeys,
	type CreateDateRangeTimezonePickerBody,
	type ListDateRangeTimezonePickerResponse,
	type DateRangeTimezonePickerRow,
} from "./api";

export function useDateRangeTimezonePickerList(): UseQueryResult<ListDateRangeTimezonePickerResponse, Error> {
	return useQuery({
		queryKey: dateRangeTimezonePickerQueryKeys.list(),
		queryFn: list,
	});
}

export function useDateRangeTimezonePickerCreate(): UseMutationResult<DateRangeTimezonePickerRow, Error, CreateDateRangeTimezonePickerBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dateRangeTimezonePickerQueryKeys.all });
		},
	});
}

export function useDateRangeTimezonePickerDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dateRangeTimezonePickerQueryKeys.all });
		},
	});
}
